import axios, { AxiosHeaders } from 'axios';
import { type Class } from 'type-fest';
import { type BaseAPI as PermissionAPI } from './permission-api-client/base';

export function initializePermissionApi<T extends PermissionAPI>(ApiClient: Class<T>): T {
  const api = new ApiClient({
    basePath: localStorage.getItem('permission_API_URL') || '',
    baseOptions: {
      withCredentials: true,
    },
    // Return false so serializeDataIfNeeded doesn't stringify - let axios handle it
    isJsonMime: () => false,
  });

  Object.getOwnPropertyNames(Object.getPrototypeOf(api)).forEach(key => {
    const name = key as keyof T;
    const item = api[name];
    if (name !== 'constructor' && typeof item === 'function') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ok
      const func: any = item;
      api[name] = func.bind(api);
    }
  });
  return api;
}

export const createInterceptor = () => {
  axios.interceptors.request.use(
    config => {
      // Respect any Authorization header already set (e.g., by HttpInterceptor via Okta)
      if (!(config.headers instanceof AxiosHeaders)) {
        config.headers = new AxiosHeaders(config.headers ?? undefined);
      }

      const headers = config.headers as AxiosHeaders;
      const existingAuth = headers.get('Authorization') ?? headers.get('authorization');
      if (existingAuth) {
        return config;
      }

      // Fallback: attach Authorization from legacy _auth storage if available
      const token = localStorage.getItem('_auth');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }

      return config;
    },
    error => Promise.reject(error instanceof Error ? error : new Error(String(error))),
  );
};

createInterceptor();
